
<div class="sports-page">

  <!-- Quick Links Header -->
  <div class="section-header">
    <span>Quick Links</span>
  </div>

  <!-- Quick Links Row -->
  <ul class="quick-links-row">
    <li>
      <a routerLink="/inplay">
        <div class="ql-icon"><i class="fas fa-stopwatch"></i></div>
        <span>In-Play</span>
      </a>
    </li>
    <li>
      <a routerLink="/multimarket">
        <div class="ql-icon"><i class="fas fa-thumbtack"></i></div>
        <span>Multi<br/>Markets</span>
      </a>
    </li>
    <li>
      <a routerLink="/home">
        <div class="ql-icon"><i class="fas fa-baseball-ball"></i></div>
        <span>Cricket</span>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/1">
        <div class="ql-icon"><i class="far fa-futbol"></i></div>
        <span>Soccer</span>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/2">
        <div class="ql-icon"><i class="fas fa-table-tennis"></i></div>
        <span>Tennis</span>
      </a>
    </li>
  </ul>

  <!-- All Sports Header -->
  <div class="section-header all-sports-header">
    <span>All Sports</span>
  </div>

  <!-- All Sports List -->
  <ul class="sports-list">
    <li>
      <a routerLink="/home" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-cricket"></div>
          <span>Cricket</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/livecasino" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-casino"></div>
          <span>Casino</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/2" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-tennis"></div>
          <span>Tennis</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/1" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-soccer"></div>
          <span>Soccer</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/7" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-horse"></div>
          <span>Horse Racing</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/2378961" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-politics"></div>
          <span>Politics</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/4339" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-grey"></div>
          <span>Greyhound Racing</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/7522" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-basketball"></div>
          <span>Basketball</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
    <li>
      <a routerLink="/allsport-highlight/66104" class="sport-row">
        <div class="sport-left">
          <div class="sport-dot dot-lottery"></div>
          <span>Lottery</span>
        </div>
        <i class="fas fa-angle-right chevron"></i>
      </a>
    </li>
  </ul>

  <!-- Bottom spacer so content isn't hidden behind bottom nav -->
  <div style="height: 70px;"></div>
</div>
